const absurd = x => {
  throw new Error('Cannot render field.');
};
export default absurd;